import {RecomendationResult} from './RecomendationResult';

export default RecomendationResult;